import * as $ from 'jquery';
import * as AutoLoadOnScroll from '../navigation/autoLoadOnScroll';
import * as SearchHistory from './searchHistory';
import * as toggleTags from '../toggleTags';

export function initialize(): void {
    bindPagination();
}

export function bindPagination($context?: JQuery): void {
    ($context ? $context.find('.js-showmore') : $('.js-showmore')).on('click', handleReadMoreClick);
}

function handleReadMoreClick(event): void {
    event.preventDefault();

    const $element = $(this);
    const count = $element.data('count');
    const countname = $element.data('countname');
    const offset = $element.data('offset');
    const offsetname = $element.data('offsetname');
    const $form = $element.closest('form');

    const $countInput = appendFormData($form, countname, count);
    const $offsetInput = appendFormData($form, offsetname, offset);

    $.post($form.data('partialurl'), $form.serialize(), (response) => handleResponse(response, $element))
        .always(() => cleanFormData($countInput, $offsetInput));
}

function appendFormData($form: JQuery, name: string, value: string): JQuery {
    return $('<input />')
        .attr('type', 'hidden')
        .attr('name', name)
        .attr('value', value)
        .appendTo($form);
}

function cleanFormData(...$inputs: JQuery[]): void {
    for (const $input of $inputs) {
        $input.remove();
    }
    SearchHistory.update();
}

function handleResponse(response, $showMoreLink): void {
    const $response = $(response);
    const $tab = $showMoreLink.closest('.js-tabcontent');
    const $searchResult = $tab.find('.search-results:first');
	const $searchItems = $response.find('.search-results > li');
	const $newShowmoreModule = $response.find('.js-showmoremodule:first');
	const $existingShowmoreModule = $showMoreLink.parent();

	$searchResult.append($searchItems);
	toggleTags.bindInputs($searchItems.find('.search-result__button'), true);

    if (!$newShowmoreModule.length) {
	    $existingShowmoreModule.remove();
        return;
    }

	$existingShowmoreModule.replaceWith($newShowmoreModule);

    bindPagination($tab);

    AutoLoadOnScroll.initialize();
}